import { Box, Dialog, DialogContent, DialogTitle, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import { format } from 'date-fns';

import DataTable from '../../../../components/DataTable';
import UserActions from './UserActions';
import FeedbackActions from './FeedbackActions';
import PhaseStatusSelect from './PhaseStatusSelect';

export default function PhasesModal({
  selectedProject,
  phaseStatus,
  onClose,
  onResetUserPhase,
  onSubmitFeedback,
  onSubmitStatus,
  onResetFeedback,
}) {
  return (
    <Dialog
      open={!!selectedProject}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
    >
      <DialogTitle>
        {`Etapas ${selectedProject?.project_name}`}
        <br />
        {`[${selectedProject?.user_name}]`}
      </DialogTitle>
      <DialogContent>
        {selectedProject?.total_phases && (
          <Box mb={2}>
            <Typography>{`Quantidade de etapas do projeto: ${selectedProject?.total_phases} etapas`}</Typography>
          </Box>
        )}
        <DataTable
          showPagination={false}
          columns={[
            { key: 'step', name: 'Etapa', isSingleLine: true, maxWidth: '280px' },
            { key: 'sent_at', name: 'Data Envio', isSingleLine: true },
            { key: 'send_actions', name: 'Envio', isSingleLine: true },
            { key: 'feedback', name: 'Feedback', isSingleLine: true },
            { key: 'feedback_date', name: 'Data Feedback', isSingleLine: true },
            { key: 'status', name: 'Status', isSingleLine: true }
          ]}
          rows={selectedProject?.phases?.map(phase => {
            return {
              id: phase?.id,
              step: phase?.phase_name,
              sent_at: format(new Date(phase?.updated_at), 'dd/MM/yyyy hh:mm:ss'),
              feedback_date: phase?.feedback_date ? format(new Date(phase?.feedback_date), 'dd/MM/yyyy hh:mm:ss') : '-',
              send_actions: (
                <UserActions
                  defaultFileUrl={phase?.project_url}
                  applicationID={selectedProject?.id}
                  applicationPhaseID={phase?.id}
                  feedbackUrl={phase?.feedback_url}
                  onReset={onResetUserPhase}
                />
              ),
              feedback: (
                <FeedbackActions
                  defaultFeedback={phase?.feedback}
                  applicationID={selectedProject?.id}
                  applicationPhaseID={phase?.id}
                  defaultFeedbackType={phase?.type}
                  onSubmitFeedback={onSubmitFeedback}
                  onResetFeedback={onResetFeedback}
                />
              ),
              status: (
                <PhaseStatusSelect
                  defaultPhaseStatus={phaseStatus?.find(status => phase?.status === status?.id)}
                  applicationID={selectedProject?.id}
                  applicationPhaseID={phase?.id}
                  phaseStatusOptions={phaseStatus}
                  onSubmitStatus={onSubmitStatus}
                />
              )
            }
          })}
        />
      </DialogContent>
    </Dialog>
  )
}